export function systemTabItem() {
  document.addEventListener("DOMContentLoaded", function () {
    const $ = document.querySelector.bind(document);
    const $$ = document.querySelectorAll.bind(document);

    const tabs = $$(".home-4-nation-tab");
    const panes = $$(".home-4-accordion-list");
    const nationMaps = $$(".home-4-map");

    if (tabs.length === 0 || panes.length === 0 || nationMaps.length === 0) {
      console.error("Không tìm thấy các phần tử cần thiết.");
      return;
    }

    // Ánh xạ tab và pane
    tabs.forEach((tab, index) => {
      tab.dataset.index = index; // Đánh dấu tab với index tương ứng
    });

    tabs.forEach((tab) => {
      tab.addEventListener("click", () => {
        const index = tab.dataset.index;

        // Xóa trạng thái active khỏi tất cả các tab
        tabs.forEach((t) => t.classList.remove("active"));
        tab.classList.add("active");

        // Ẩn toàn bộ panes và nationMaps
        panes.forEach((pane) => pane.classList.remove("show"));
        nationMaps.forEach((map) => map.classList.remove("show"));

        // Hiển thị pane và map tương ứng
        panes[index]?.classList.add("show");
        nationMaps[index]?.classList.add("show");
      });
    });
  });
}

systemTabItem();
